
 
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {Observable, pipe, throwError} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import decode from 'jwt-decode';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import {AppSettings} from '../settings';
 
@Injectable({
  providedIn: 'root'
})
export class TemplateService {

  private message: string; 

  constructor(private _router: Router,private http: HttpClient ) {

    
   }



   getTemplateList(obj:any):any{

    try{
      let  httpOptions = {
        headers: new HttpHeaders({
          'Content-Type':  'application/json',
          "Authorization": "Bearer "+obj.token,

        })
      };

      let api_url =AppSettings.API_ENDPOINT+'template.php';

     return this.http.post<any>(api_url, obj.details,httpOptions);



    }catch(err){

      this._router.navigate(['/login']);

    }

  }
   
  
   createtemplateData(obj:any):any{ 
     
    try{
       
      
      let  httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
            "Authorization": "Bearer "+obj.token,
          })
        };

       
        let api_url =AppSettings.API_ENDPOINT+'template.php';
    
        return this.http.post<any>(api_url,obj.details,httpOptions);


      }catch(err){
  
  
        // notify system api error 
        this._router.navigate(['/login']);
  
      }


  } 


   templateDataById(obj:any):any{ 
     
    try{
       
      
      let  httpOptions = {
          headers: new HttpHeaders({
            'Content-Type':  'application/json',
            "Authorization": "Bearer "+obj.token,
          })
        };

       
        let api_url =AppSettings.API_ENDPOINT+'template.php';
    
        return this.http.post<any>(api_url,{'id':obj.id ,'page':'template'},httpOptions);


      }catch(err){
  
  
        // notify system api error 
        this._router.navigate(['/login']);
  
      }


  } 


}